import React, { useState, useEffect } from "react";
import { JaaSMeeting } from "@jitsi/react-sdk";
import { database, ref, set, onValue, off } from "../../services/firebase";
import Patients from "./Patients";
import generate from "../../helpers/generateJWT";
import jsonwebtoken from "jsonwebtoken";

const defaultState = {
  participantId: "",
  roomId: "",
  password: "",
};

const Nurse = () => {
  const [roomData, setRoomData] = useState(defaultState);
  const [open, setOpen] = useState(false);
  const [jwt, setJwt] = useState(localStorage.getItem("jaas_jwt"));

  const onCallClose = () => {
    roomData.participantId && set(ref(database, "requests/ui-kit/" + roomData.participantId), null);
    setOpen(false);
  };

  useEffect(() => {
    let patientListener;
    if (roomData.participantId) {
      patientListener = ref(database, "requests/ui-kit/" + roomData.participantId);
      onValue(patientListener, (snapshot) => {
        const data = snapshot.val();
        if (!data) {
          setRoomData(defaultState);
          setOpen(false);
        }
      });
    }

    return () => {
      patientListener && off(patientListener);
    };
  }, [roomData]);

  useEffect(() => {
    let token = localStorage.getItem("jaas_jwt");
    const secretKey = process.env.REACT_APP_JITSI_PRIVATE_KEY.replace(/\\n/g, "\n");
    const publicKey = process.env.REACT_APP_JITSI_PUBLIC_KEY.replace(/\\n/g, "\n");
    jsonwebtoken.verify(token, publicKey, (err) => {
      if (err) setJwt(generate(secretKey, {}));
    });
  }, [open]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        color: "white",
      }}
    >
      {open ? (
        <>
          <JaaSMeeting
            appId={process.env.REACT_APP_JITSI_APP_ID}
            roomName={roomData.roomId}
            jwt={jwt}
            configOverwrite={{
              disableThirdPartyRequests: true,
              disableLocalVideoFlip: true,
              backgroundAlpha: 0.5,
              prejoinPageEnabled: false,
              startWithAudioMuted: false,
              startWithVideoMuted: true,
            }}
            interfaceConfigOverwrite={{
              VIDEO_LAYOUT_FIT: "nocrop",
              MOBILE_APP_PROMO: false,
              TILE_VIEW_MAX_COLUMNS: 4,
              TOOLBAR_ALWAYS_VISIBLE: true,
            }}
            onApiReady={(externalApi) => {
              externalApi.on("readyToClose", onCallClose);
              // externalApi.on("videoConferenceJoined", () => {
              //   afterJoin();
              //   externalApi.executeCommand("password", roomData.password);
              // });
            }}
            getIFrameRef={(iframeRef) => {
              iframeRef.style.height = "100%";
              iframeRef.style.width = "100%";
            }}
          />
        </>
      ) : (
        <Patients setOpen={setOpen} setRoomData={setRoomData} />
      )}
    </div>
  );
};

export default Nurse;
